import styled from 'styled-components'

import UserFilled from '../../icons/UserFilled'
import theme from '../../theme'

const Badge = styled.span`
  background-color: ${theme.colors.gray5};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  color: ${theme.colors.white};
  font-weight: 600;
  font-size: 16px;
`

const ActiveBadge = styled.span`
  z-index: 1;
  position: absolute;
  background-color: ${theme.colors.gray5};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  border: 2px solid ${theme.colors.white};
  color: ${theme.colors.white};
  font-weight: 600;
  font-size: 16px;
  top: 3px;
  left: 3px;
`

export interface CardContainerProps {
  elevationLevel?: 1 | 2 | 3
  backgroundColor?: string
  borderColor?: string
}

const CardContainer = styled.span<CardContainerProps>`
  background-color: ${(props) => props.backgroundColor ?? theme.colors.gray1};
  ${(props) => {
    switch (props.elevationLevel) {
      case 1:
        return 'box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);'
      case 2:
        return 'box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.04);'
      case 3:
        return 'box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08), 0px 2px 4px rgba(0, 0, 0, 0.04);'
      default:
        return ''
    }
  }}
  ${(props) => (props.borderColor ? 'border: 1px solid ' + props.borderColor + ';' : '')}
  padding: 12px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const LiveIndicatorWrapper = styled.span`
  background: transparent;
  border-radius: 100%;
  opacity: 0.8;
  width: 46px;
  height: 46px;
  position: relative;
  background: ${theme.colors.primary};

  svg {
    position: absolute;
    bottom: -6px;
    right: -6px;
    z-index: 999;
    background: ${theme.colors.primary};
    border-radius: 100%;
    border: 2px solid white;
    padding: 3px;
    font-size: 22px;
    color: white;
  }

  .pulse-1 {
    position: absolute;
    border-radius: 100%;
    background: ${theme.colors.primary}30;
    animation: pulsating-pulse-1 2s linear infinite;
  }

  @keyframes pulsating-pulse-1 {
    25% {
      top: 3px;
      left: 3px;
      width: 40px;
      height: 40px;
      background: ${theme.colors.primary}30;
    }
    50% {
      top: 6px;
      left: 6px;
      width: 34px;
      height: 34px;
      background: ${theme.colors.primary}30;
    }
    75% {
      top: -3px;
      left: -3px;
      width: 52px;
      height: 52px;
      background: ${theme.colors.primary}30;
    }
    100% {
      top: -1px;
      left: -1px;
      width: 48px;
      height: 48px;
      background: ${theme.colors.primary}20;
    }
  }

  .pulse-2 {
    position: absolute;
    top: 4px;
    left: 4px;
    border-radius: 100%;
    background: ${theme.colors.primary}30;
    animation: pulsating-pulse-2 2s linear infinite;
  }

  @keyframes pulsating-pulse-2 {
    25% {
      top: 4px;
      left: 4px;
      width: 38px;
      height: 38px;
      background: ${theme.colors.primary}30;
    }
    50% {
      top: 8px;
      left: 8px;
      width: 30px;
      height: 30px;
      background: ${theme.colors.primary}30;
    }
    75% {
      top: -5px;
      left: -5px;
      width: 56px;
      height: 56px;
      background: ${theme.colors.primary}20;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 46px;
      height: 46px;
      background: ${theme.colors.primary}30;
    }
  }
`

const TextInfoLight = styled.span<{ margin?: string }>`
  font-size: ${theme.fontSizes.small};
  font-weight: ${theme.fontWeights.normal};
  margin: ${({ margin }) => margin || '0'};
  color: ${theme.colors.gray8};
`

const TextInfoBold = styled.span`
  font-size: ${theme.fontSizes.medium};
  font-weight: ${theme.fontWeights.semiBold};
  color: ${theme.colors.gray9};
`

const StyledUserIcon = styled(UserFilled)`
  margin-right: 6px;
  margin-left: 18px;
`
StyledUserIcon.defaultProps = { style: { color: theme.colors.gray8 } }

const RightSideIconWrapper = styled.span`
  margin-right: 5px;
  display: flex;
  align-items: center;
`

export {
  Badge,
  ActiveBadge,
  CardContainer,
  LiveIndicatorWrapper,
  TextInfoBold,
  TextInfoLight,
  StyledUserIcon,
  RightSideIconWrapper,
}
